import { STORAGE_KEY } from '@/config'

export default () => {
  if (window.localStorage[STORAGE_KEY]) {
    var parsed = JSON.parse(window.localStorage[STORAGE_KEY])
    if (parsed.auth && parsed.auth.tokens) {
      return {
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + parsed.auth.tokens.access_token
      }
    }
  }
}
